<template>
	<component v-bind:is="'layout-blank'">
		<div class="h-full flex flex-col">
			<div class="bg-green-500 px-6 py-4 text-white">
				<div class="flex justify-between items-baseline pr-4 mr-6">
					<h1 class="text-3xl font-bold">
						{{ __(productGrade) }} - {{ __("Your contract conclusions") }}
					</h1>
				</div>

				<ui-button
					type="blank"
					class="absolute right-5 top-5"
					v-on:click="closeIframeModal()"
				>
					<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
				</ui-button>
			</div>

			<p class="ml-4 mt-2 mb-1 text-gray-500 font-semibold">
				{{ __("Harvest year") }}
			</p>

			<ul class="list-none mt-4 ml-4 mb-2">
				<li v-for="(year, i) in yearSelection" class="inline-block">
					<a
						:href="
							$route('my_contracts.matif_chart', {
								tickerCode: currentTickerCode,
								year: year,
								filterType: currentFilterType,
							})
						"
						class="text-white bg-gray-400 px-5 py-3"
						:class="
							(i == 0
								? 'rounded-tl-lg'
								: i + 1 == yearSelection.length
								? 'rounded-tr-lg'
								: '') + (year == currentYear ? ' bg-gray-600' : '')
						"
						>{{ year }}</a
					>
				</li>
			</ul>

			<div class="mt-4" ref="chart" style="width: 100%; height: 461px"></div>
		</div>
	</component>
</template>

<script>
import UiWizzard from "../components/Ui/Wizzard.vue";
import * as echarts from "echarts";
function padTo2Digits(num) {
	return num.toString().padStart(2, "0");
}
export default {
	mixins: [UiWizzard],
	props: {
		contracts: {
			type: Array,
			required: true,
		},
		externalContracts: {
			type: Array,
			required: true,
		},
		futureValues: {
			type: Array,
			required: true,
		},
		futureValues2: {
			type: Array,
			required: true,
		},
		currentYear: {
			type: Number,
			required: true,
		},
		currentTickerCode: {
			type: String,
			required: true,
		},
		productGrade: {
			type: String,
			required: true,
		},
		yearSelection: {
			type: Array,
			required: true,
		},
		date_from: {
			type: String,
			required: true,
		},
		date_to: {
			type: String,
			required: true,
		},
		currentFilterType: {
			type: String,
			required: true,
		},
	},
	data() {
		return {};
	},
	methods: {},
	mounted() {
		const valueList = [];
		const valueListExternal = [];
		var maxValue = null;
		var minValue = null;
		this.contracts.forEach((element) => {
			let contractDate = new Date(element.created_at);
			valueList.push({
				name: "Kaufpreis cropspot",
				value: [
					contractDate.getFullYear() +
						"-" +
						padTo2Digits(contractDate.getMonth() + 1) +
						"-" +
						padTo2Digits(contractDate.getDate()),
					element.price__mt,
				],
				qty: element.qty__mt,
				date_string: element.contract_date_string,
			});
			maxValue =
				element.price__mt > maxValue || maxValue == null
					? element.price__mt
					: maxValue;
			minValue =
				element.price__mt < minValue || minValue == null
					? element.price__mt
					: minValue;
		});
		this.externalContracts.forEach((element) => {
			valueListExternal.push({
				name: "Kaufpreis ext.",
				value: [element.contract_date, element.price__mt],
				qty: element.qty__mt,
				date_string: element.contract_date_string,
			});
			maxValue =
				element.price__mt > maxValue || maxValue == null
					? element.price__mt
					: maxValue;
			minValue =
				element.price__mt < minValue || minValue == null
					? element.price__mt
					: minValue;
		});
		const seriesData = [];
		const seriesData2 = [];
		this.futureValues.forEach((element) => {
			element.values.forEach((item) => {
				seriesData.push({
					name: element.name,
					value: [item.date, item.price],
				});
				maxValue =
					item.price > maxValue || maxValue == null ? item.price : maxValue;
				minValue =
					item.price < minValue || minValue == null ? item.price : minValue;
			});
		});
		this.futureValues2.forEach((element) => {
			element.values.forEach((item) => {
				seriesData2.push({
					name: element.name,
					value: [item.date, item.price],
				});
				maxValue =
					item.price > maxValue || maxValue == null ? item.price : maxValue;
				minValue =
					item.price < minValue || minValue == null ? item.price : minValue;
			});
		});
		maxValue = parseFloat(maxValue) + 10;
		if (parseFloat(minValue) >= 10) {
			minValue = parseFloat(minValue) - 10;
		}
		let chartDom = this.$refs.chart,
			that = this,
			option = {
				legend: {
					left: "auto",
					right: 75,
				},
				tooltip: {
					trigger: "axis",
					//valueFormatter: (value) => parseFloat(value).toFixed(2) + "€",
					formatter(params) {
						var date = new Date(params[0]["data"].value[0]);
						let title =
							padTo2Digits(date.getDate()) +
							"." +
							padTo2Digits(date.getMonth() + 1) +
							"." +
							date.getFullYear();
						let content = "";
						params.forEach((item) => {
							content +=
								"<br />" +
								item["marker"] +
								"&nbsp;" +
								item["data"].name +
								'<span style="float: right; margin-left: 20px"><b>' +
								item["data"].value[1] +
								"&euro;</b></span>";
						});
						return title + content;
					},
				},
				xAxis: {
					type: "time",
					min: this.date_from,
					max: this.date_to,
					axisLabel: { formatter: "{MMM} {yy}" },
					splitLine: {
						show: false,
					},
				},
				yAxis: [
					{
						name: "Euro/t",
						nameLocation: "center",
						nameGap: 42,
						position: "left",
						min: minValue,
						max: maxValue,
						axisLabel: {
							showMinLabel: false,
							showMaxLabel: false,
						},
					},
					{
						name: "Euro/t - right",
						position: "right",
						min: minValue,
						max: maxValue,
						show: false,
					},
				],
				series: [
					{
						type: "line",
						data: seriesData,
						name: "MATIF",
						areaStyle: {
							color: "#cade86",
						},
						itemStyle: {
							color: "#cade86",
						},
						lineStyle: {
							width: 2,
							color: "#454545",
						},
						color: "#cade86",
						showSymbol: false,
						yAxisIndex: 0,
						z: 0,
					},
					{
						type: "line",
						data: seriesData2,
						name: "MATIF",
						areaStyle: {
							color: "#aeb1b1",
						},
						itemStyle: {
							color: "#cade86",
						},
						lineStyle: {
							width: 2,
							color: "#454545",
						},
						markPoint: {
							itemStyle: {
								color: "#ffffff",
							},
						},
						color: "#aeb1b1",
						showSymbol: false,
						yAxisIndex: 0,
						z: 0,
					},
					{
						symbolSize: 20,
						data: valueList,
						name: "Kaufpreis cropspot",
						type: "scatter",
						itemStyle: {
							color: "#f19300",
						},
						yAxisIndex: 1,
						z: 1,
						label: {
							show: true,
							position: "bottom",
							formatter: (params) => {
								return parseFloat(params.data["value"][1]).toFixed(2) + "€";
							},
						},
						tooltip: {
							formatter(params) {
								var date = new Date(params.value[0]);
								let content =
									padTo2Digits(date.getDate()) +
									"." +
									padTo2Digits(date.getMonth() + 1) +
									"." +
									date.getFullYear() +
									"<br />" +
									//params.marker +
									//"&nbsp;" +
									'<div><b>Menge: <span style="float: right; margin-left: 20px">' +
									params.data.qty +
									"&nbsp;t</span></b></div>" +
									'<div><b>Preis: <span style="float: right; margin-left: 20px">' +
									params.value[1] +
									"&nbsp;&euro;/t</span></b></div>" +
									'<div>Termin: <span style="float: right; margin-left: 20px">' +
									params.data.date_string +
									"</span></div>";
								return content;
							},
							backgroundColor: "#f19300",
							textStyle: {
								color: "#fff",
							},
						},
					},
					{
						symbolSize: 20,
						data: valueListExternal,
						name: "Kaufpreis ext.",
						type: "scatter",
						itemStyle: {
							color: "#454545",
						},
						yAxisIndex: 1,
						z: 1,
						label: {
							show: true,
							position: "bottom",
							formatter: (params) => {
								return parseFloat(params.data["value"][1]).toFixed(2) + "€";
							},
						},
						tooltip: {
							formatter(params) {
								var date = new Date(params.value[0]);
								let content =
									padTo2Digits(date.getDate()) +
									"." +
									padTo2Digits(date.getMonth() + 1) +
									"." +
									date.getFullYear() +
									"<br />" +
									//params.marker +
									//"&nbsp;" +
									'<div><b>Menge: <span style="float: right; margin-left: 20px">' +
									params.data.qty +
									"&nbsp;t</span></b></div>" +
									'<div><b>Preis: <span style="float: right; margin-left: 20px">' +
									params.value[1] +
									"&nbsp;&euro;/t</span></b></div>" +
									'<div>Termin: <span style="float: right; margin-left: 20px">' +
									params.data.date_string +
									"</span></div>";
								return content;
							},
							backgroundColor: "#454545",
							textStyle: {
								color: "#fff",
							},
						},
					},
				],
			};

		var myChart = echarts.init(chartDom);
		myChart.setOption(option);
		window.addEventListener("resize", function () {
			myChart.resize();
		});

		myChart
			.on("mouseover", { seriesIndex: 2 }, function (params) {
				myChart.setOption({
					tooltip: {
						trigger: "item",
					},
				});
			})
			.on("mouseout", { seriesIndex: 2 }, function (params) {
				myChart.setOption({
					tooltip: {
						trigger: "axis",
					},
				});
			})
			.on("mouseover", { seriesIndex: 3 }, function (params) {
				myChart.setOption({
					tooltip: {
						trigger: "item",
					},
				});
			})
			.on("mouseout", { seriesIndex: 3 }, function (params) {
				myChart.setOption({
					tooltip: {
						trigger: "axis",
					},
				});
			});
	},
};
</script>
